// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$String from "../../../../../../node_modules/rescript/lib/es6/string.js";
import * as CityConfig$PorterinFeature from "../../../containers/partners/domain/repo/types/CityConfig.mjs";

function cityToGeoRegionId(city) {
  var value = $$String.lowercase_ascii(city);
  if (value === CityConfig$PorterinFeature.mumbai) {
    return 1;
  } else if (value === CityConfig$PorterinFeature.delhi_NCR || value === CityConfig$PorterinFeature.delhi) {
    return 2;
  } else if (value === CityConfig$PorterinFeature.bangalore) {
    return 3;
  } else if (value === CityConfig$PorterinFeature.hyderabad) {
    return 4;
  } else if (value === CityConfig$PorterinFeature.chennai) {
    return 5;
  } else if (value === CityConfig$PorterinFeature.ahmedabad) {
    return 6;
  } else if (value === CityConfig$PorterinFeature.jaipur) {
    return 7;
  } else if (value === CityConfig$PorterinFeature.pune) {
    return 8;
  } else if (value === CityConfig$PorterinFeature.kolkata) {
    return 9;
  } else if (value === CityConfig$PorterinFeature.surat) {
    return 10;
  } else if (value === CityConfig$PorterinFeature.lucknow) {
    return 11;
  } else if (value === CityConfig$PorterinFeature.coimbatore) {
    return 12;
  } else if (value === CityConfig$PorterinFeature.indore) {
    return 13;
  } else if (value === CityConfig$PorterinFeature.nagpur) {
    return 14;
  } else if (value === CityConfig$PorterinFeature.chandigarh) {
    return 15;
  } else if (value === CityConfig$PorterinFeature.vadodara) {
    return 16;
  } else if (value === CityConfig$PorterinFeature.ludhiana) {
    return 17;
  } else if (value === CityConfig$PorterinFeature.kochi) {
    return 18;
  } else if (value === CityConfig$PorterinFeature.nashik) {
    return 19;
  } else if (value === CityConfig$PorterinFeature.visakhapatnam) {
    return 29;
  } else if (value === CityConfig$PorterinFeature.kanpur) {
    return 20;
  } else if (value === CityConfig$PorterinFeature.trivandrum) {
    return 30;
  } else if (value === CityConfig$PorterinFeature.tiruppur) {
    return 1032;
  } else if (value === CityConfig$PorterinFeature.kozhikode) {
    return 1033;
  } else if (value === CityConfig$PorterinFeature.rajkot) {
    return 1034;
  } else if (value === CityConfig$PorterinFeature.bhopal) {
    return 1035;
  } else if (value === CityConfig$PorterinFeature.anand) {
    return 1036;
  } else if (value === CityConfig$PorterinFeature.agra) {
    return 1037;
  } else if (value === CityConfig$PorterinFeature.meerut) {
    return 1038;
  } else if (value === CityConfig$PorterinFeature.thrissur) {
    return 1040;
  } else if (value === CityConfig$PorterinFeature.madurai) {
    return 1041;
  } else if (value === CityConfig$PorterinFeature.gwalior) {
    return 1042;
  } else if (value === CityConfig$PorterinFeature.aurangabad) {
    return 1043;
  } else if (value === CityConfig$PorterinFeature.mysore) {
    return 1044;
  } else if (value === CityConfig$PorterinFeature.jabalpur) {
    return 1045;
  } else if (value === CityConfig$PorterinFeature.nadiad) {
    return 1046;
  } else if (value === CityConfig$PorterinFeature.salem) {
    return 1047;
  } else if (value === CityConfig$PorterinFeature.vijayawada) {
    return 1048;
  } else if (value === CityConfig$PorterinFeature.jalandhar) {
    return 1049;
  } else if (value === CityConfig$PorterinFeature.bharuch) {
    return 1050;
  } else if (value === CityConfig$PorterinFeature.ambala) {
    return 1051;
  } else if (value === CityConfig$PorterinFeature.raipur) {
    return 1052;
  } else if (value === CityConfig$PorterinFeature.bhilai) {
    return 1053;
  } else if (value === CityConfig$PorterinFeature.mangalore) {
    return 1054;
  } else if (value === CityConfig$PorterinFeature.patna) {
    return 1055;
  } else if (value === CityConfig$PorterinFeature.prayagraj) {
    return 1056;
  } else if (value === CityConfig$PorterinFeature.jodhpur) {
    return 1057;
  } else if (value === CityConfig$PorterinFeature.ajmer) {
    return 1058;
  } else if (value === CityConfig$PorterinFeature.kota) {
    return 1059;
  } else if (value === CityConfig$PorterinFeature.varanasi) {
    return 1060;
  } else if (value === CityConfig$PorterinFeature.bhavnagar) {
    return 1061;
  } else if (value === CityConfig$PorterinFeature.jamnagar) {
    return 1062;
  } else if (value === CityConfig$PorterinFeature.ujjain) {
    return 1063;
  } else if (value === CityConfig$PorterinFeature.ranchi) {
    return 2064;
  } else if (value === CityConfig$PorterinFeature.jalgaon) {
    return 2065;
  } else if (value === CityConfig$PorterinFeature.goa) {
    return 2066;
  } else if (value === CityConfig$PorterinFeature.guwahati) {
    return 2067;
  } else if (value === CityConfig$PorterinFeature.panipat) {
    return 2068;
  } else if (value === CityConfig$PorterinFeature.bhubaneswar) {
    return 2069;
  } else if (value === CityConfig$PorterinFeature.ayodhya) {
    return 2070;
  } else {
    return 3;
  }
}

function geoRegionIdToCity(id) {
  if (id >= 1032) {
    if (id >= 2064) {
      if (id >= 2071) {
        return CityConfig$PorterinFeature.bangalore;
      }
      switch (id) {
        case 2064 :
            return CityConfig$PorterinFeature.ranchi;
        case 2065 :
            return CityConfig$PorterinFeature.jalgaon;
        case 2066 :
            return CityConfig$PorterinFeature.goa;
        case 2067 :
            return CityConfig$PorterinFeature.guwahati;
        case 2068 :
            return CityConfig$PorterinFeature.panipat;
        case 2069 :
            return CityConfig$PorterinFeature.bhubaneswar;
        case 2070 :
            return CityConfig$PorterinFeature.ayodhya;
        
      }
    } else {
      if (id >= 1064) {
        return CityConfig$PorterinFeature.bangalore;
      }
      switch (id) {
        case 1032 :
            return CityConfig$PorterinFeature.tiruppur;
        case 1033 :
            return CityConfig$PorterinFeature.kozhikode;
        case 1034 :
            return CityConfig$PorterinFeature.rajkot;
        case 1035 :
            return CityConfig$PorterinFeature.bhopal;
        case 1036 :
            return CityConfig$PorterinFeature.anand;
        case 1037 :
            return CityConfig$PorterinFeature.agra;
        case 1038 :
            return CityConfig$PorterinFeature.meerut;
        case 1039 :
            return CityConfig$PorterinFeature.bangalore;
        case 1040 :
            return CityConfig$PorterinFeature.thrissur;
        case 1041 :
            return CityConfig$PorterinFeature.madurai;
        case 1042 :
            return CityConfig$PorterinFeature.gwalior;
        case 1043 :
            return CityConfig$PorterinFeature.aurangabad;
        case 1044 :
            return CityConfig$PorterinFeature.mysore;
        case 1045 :
            return CityConfig$PorterinFeature.jabalpur;
        case 1046 :
            return CityConfig$PorterinFeature.nadiad;
        case 1047 :
            return CityConfig$PorterinFeature.salem;
        case 1048 :
            return CityConfig$PorterinFeature.vijayawada;
        case 1049 :
            return CityConfig$PorterinFeature.jalandhar;
        case 1050 :
            return CityConfig$PorterinFeature.bharuch;
        case 1051 :
            return CityConfig$PorterinFeature.ambala;
        case 1052 :
            return CityConfig$PorterinFeature.raipur;
        case 1053 :
            return CityConfig$PorterinFeature.bhilai;
        case 1054 :
            return CityConfig$PorterinFeature.mangalore;
        case 1055 :
            return CityConfig$PorterinFeature.patna;
        case 1056 :
            return CityConfig$PorterinFeature.prayagraj;
        case 1057 :
            return CityConfig$PorterinFeature.jodhpur;
        case 1058 :
            return CityConfig$PorterinFeature.ajmer;
        case 1059 :
            return CityConfig$PorterinFeature.kota;
        case 1060 :
            return CityConfig$PorterinFeature.varanasi;
        case 1061 :
            return CityConfig$PorterinFeature.bhavnagar;
        case 1062 :
            return CityConfig$PorterinFeature.jamnagar;
        case 1063 :
            return CityConfig$PorterinFeature.ujjain;
        
      }
    }
  } else {
    switch (id) {
      case 1 :
          return CityConfig$PorterinFeature.mumbai;
      case 2 :
          return CityConfig$PorterinFeature.delhi_NCR;
      case 4 :
          return CityConfig$PorterinFeature.hyderabad;
      case 5 :
          return CityConfig$PorterinFeature.chennai;
      case 6 :
          return CityConfig$PorterinFeature.ahmedabad;
      case 7 :
          return CityConfig$PorterinFeature.jaipur;
      case 8 :
          return CityConfig$PorterinFeature.pune;
      case 9 :
          return CityConfig$PorterinFeature.kolkata;
      case 10 :
          return CityConfig$PorterinFeature.surat;
      case 11 :
          return CityConfig$PorterinFeature.lucknow;
      case 12 :
          return CityConfig$PorterinFeature.coimbatore;
      case 13 :
          return CityConfig$PorterinFeature.indore;
      case 14 :
          return CityConfig$PorterinFeature.nagpur;
      case 15 :
          return CityConfig$PorterinFeature.chandigarh;
      case 16 :
          return CityConfig$PorterinFeature.vadodara;
      case 17 :
          return CityConfig$PorterinFeature.ludhiana;
      case 18 :
          return CityConfig$PorterinFeature.kochi;
      case 19 :
          return CityConfig$PorterinFeature.nashik;
      case 20 :
          return CityConfig$PorterinFeature.kanpur;
      case 3 :
      case 21 :
      case 22 :
      case 23 :
      case 24 :
      case 25 :
      case 26 :
      case 27 :
      case 28 :
          return CityConfig$PorterinFeature.bangalore;
      case 29 :
          return CityConfig$PorterinFeature.visakhapatnam;
      case 30 :
          return CityConfig$PorterinFeature.trivandrum;
      default:
        return CityConfig$PorterinFeature.bangalore;
    }
  }
}

function toDisplayCity(city) {
  if (city === CityConfig$PorterinFeature.delhi) {
    return CityConfig$PorterinFeature.delhi_NCR;
  } else {
    return city;
  }
}

export {
  cityToGeoRegionId ,
  geoRegionIdToCity ,
  toDisplayCity ,
}
/* No side effect */
